/* eslint-disable class-methods-use-this */
import React from 'react';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import { Box } from 'components/ui';
import ComponentList from 'components/Content/ComponentList';
import contentConstants from 'constants/content';
import BeautyInsiderModules from 'components/Content/BeautyInsider/BeautyInsiderModules';
import ProfileBanner from 'components/ProfileBanner';
import BeautyInsiderSummary from 'components/Content/BeautyInsider/BeautyInsiderSummary';
import beautyInsiderPageBindings from 'analytics/bindingMethods/pages/beautyInsider/beautyInsiderPageBindings';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Storage from 'utils/localStorage/Storage';

const { CONTEXTS } = contentConstants;

class BeautyInsider extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            isAccessTokenPresent: false
        };
    }

    fetchUserData = profileId => {
        const { fetchClientSummary, fetchRecentlyRedeemedRewards, getAccountHistorySlice } = this.props;

        fetchClientSummary(profileId, true);
        fetchRecentlyRedeemedRewards(profileId);
        getAccountHistorySlice(profileId);
    };

    triggerAnalytics = () => {
        const { isAtLeastRecognized } = this.props;
        beautyInsiderPageBindings.setPageLoadAnalytics(isAtLeastRecognized);
    };

    componentDidMount() {
        const { fetchBeautyOffers, fetchBiRewards, user } = this.props;
        const { country, language } = Sephora.renderQueryParams;
        const isAccessTokenPresent = !!Storage.local.getItem(LOCAL_STORAGE.AUTH_ACCESS_TOKEN);
        this.setState({ isAccessTokenPresent });

        fetchBeautyOffers(country, language);

        if (user.isInitialized && user.profileId) {
            this.fetchUserData(user.profileId);
            this.triggerAnalytics();
        }

        const { isInitialized, defaultSACountryCode, defaultSAZipCode } = user;
        const saDataReady = Boolean(isInitialized && isAccessTokenPresent && defaultSACountryCode && defaultSAZipCode);

        if (saDataReady) {
            fetchBiRewards();
        }
    }

    componentDidUpdate(prevProps) {
        const { user, fetchBiRewards } = this.props;
        const { isAccessTokenPresent } = this.state;

        if (user.profileId !== prevProps.user.profileId) {
            this.fetchUserData(user.profileId);
        }

        const defaultSADataChanged =
            user.defaultSACountryCode !== prevProps.user.defaultSACountryCode || user.defaultSAZipCode !== prevProps.user.defaultSAZipCode;

        if (user.isInitialized && defaultSADataChanged && isAccessTokenPresent) {
            fetchBiRewards();
        }

        if (user.isInitialized && prevProps.user.isInitialized !== user.isInitialized) {
            this.triggerAnalytics();
        }
    }

    hardCodedModules = () => {
        return (
            <>
                <BeautyInsiderModules user={this.props.user} />
            </>
        );
    };

    renderContentZone = content => {
        return (
            <ComponentList
                enablePageRenderTracking={true}
                trackingCount={1}
                context={CONTEXTS.CONTAINER}
                removeLastItemMargin={true}
                removeFirstItemMargin={true}
                items={content}
            />
        );
    };

    signedInUserSection = (topContent, bottomContent) => {
        return (
            <Box marginTop={5}>
                <BeautyInsiderSummary />
                <Box marginTop={[6, 7]}>{this.renderContentZone(topContent)}</Box>
                <Box>{this.hardCodedModules()}</Box>
                <Box marginTop={[6, 7]}>{this.renderContentZone(bottomContent)}</Box>
            </Box>
        );
    };

    notSignedInUserSection = bottomContent => {
        return <Box marginTop={[6, 7]}>{this.renderContentZone(bottomContent)}</Box>;
    };

    render() {
        const { userIsInitialized, isAtLeastRecognized, content } = this.props;

        return (
            <>
                <ProfileBanner origin='beautyInsider' />
                {!userIsInitialized
                    ? null
                    : isAtLeastRecognized
                        ? this.signedInUserSection(content.topContent, content.bottomContent)
                        : this.notSignedInUserSection(content.bottomContent)}
            </>
        );
    }
}

export default wrapComponent(BeautyInsider, 'BeautyInsider');
